import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageService} from '../services/page.service';
import {ClienteComponent} from '../../components/cliente/cliente.component';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {NumPedidoModalComponent} from '../modal/num-pedido-modal/num-pedido-modal.component';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-justificante',
  templateUrl: './justificante.component.html',
  styleUrls: ['./justificante.component.css']
})
export class JustificanteComponent implements OnInit, AfterContentChecked {
  @ViewChild('clienteComprador', {static: false}) cliente: ClienteComponent;
  datosVehiculos: FormGroup;
  documentos: FormGroup;
  DatoCliente: any;
  isEditable = true;
  solicitud: string;
  title: string;
  formData: FormData;
  observacion: string;
  clasif: any;
  spinnerEITV = false;


  constructor(private cdRef: ChangeDetectorRef, private fb: FormBuilder, private servicio: PageService,
              private router: Router, public dialog: MatDialog) {

  }

  ngOnInit(): void {
    this.inicio();
    this.numPedidoModal();
  }

  numPedidoModal(): void{
    const dialogRef2 = this.dialog.open(NumPedidoModalComponent, {
      width: '400px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog'
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get datosCliente(): any {
    return this.cliente ? this.cliente.cliente$ : null;
  }

  get bastidorNoValido(): any {
    return this.datosVehiculos.get('bastidor').invalid && this.datosVehiculos.get('bastidor').touched;
  }

  get matriculaNoValido(): any {
    return this.datosVehiculos.get('matricula').invalid && this.datosVehiculos.get('matricula').touched;
  }

  get marcaNoValido(): any {
    return this.datosVehiculos.get('marca').invalid && this.datosVehiculos.get('marca').touched;
  }

  get modeloNoValido(): any {
    return this.datosVehiculos.get('modelo').invalid && this.datosVehiculos.get('modelo').touched;
  }

  inicio(): void{
    this.solicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.clasificaciones();
    this.crearFormulario();
    if (this.solicitud !== 'null') {
      console.log('aca');
      this.getSolicitud();
    }
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      bastidor: ['', [Validators.required]],
      matricula: ['', [Validators.required]],
      tipoVehiculo: ['10', [Validators.required]],
      marca: ['', [Validators.required]],
      modelo: ['', [Validators.required]],
      observaciones: '',
    });

  }

  getSolicitud(): any {
    this.servicio.getOneSolicitud(this.solicitud).subscribe((res) => {
      this.setDatos(res);
    }, (error) => {
      console.log(error);
    });
  }

  getVehiculo(): void {
    if (this.datosVehiculos.value.matricula.length > 5) {
    this.servicio.getOneVehiculo(this.datosVehiculos.value.matricula).subscribe((res) => {
      if (res.matricula === this.datosVehiculos.value.matricula) {
        if (res.vehiculo != null) {
          this.setDato(res.vehiculo);
        } else {
          this.datosVehiculos.setValue({
            tipo: '',
            colaborador: '',
            usuarioweb: '',
            bastidor: '',
            matricula: this.datosVehiculos.value.matricula,
            tipoVehiculo: '10',
            marca: '',
            modelo: '',
            observaciones: '',
          });
        }
      }
    }, (error) => {
      console.log(error);
    });
   } else {
      this.datosVehiculos.setValue({
        tipo: '',
        colaborador: '',
        usuarioweb: '',
        bastidor: '',
        matricula: this.datosVehiculos.value.matricula,
        tipoVehiculo: '10',
        marca: '',
        modelo: '',
        observaciones: '',
      });
    }
  }

  setDatos(datos): any {
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    if (datos.tipoVehiculo !== null) {
      const clasif = datos.tipoVehiculo.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
      console.log(this.datosVehiculos.value.tipoVehiculo);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
  }

  siguiente(): any {
    console.log(this.datosVehiculos.value);
  }

  siguiente2($event: any): void {
    this.DatoCliente = {...$event, ...this.datosVehiculos.value};
    const c = this.clasif.find(res => res.id === this.datosVehiculos.value.tipoVehiculo);
    console.log(c);
    this.DatoCliente.tipoVehiculo = c.descripcion;
    this.DatoCliente.tipo = 'JUSTIFICANTE';
    this.DatoCliente.numPedido = sessionStorage.getItem('numPedidoComun');
    this.DatoCliente.colaborador = sessionStorage.getItem('colaborador');
    this.DatoCliente.usuarioweb = sessionStorage.getItem('email');
    console.log(this.DatoCliente);
  }

  clasificaciones(): void {
    this.clasif = [{id: '03', descripcion: '03xx – CICLOMOTOR'}, {id: '04', descripcion: '04xx – MOTOCICLETA'},
      {id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS'}, {id: '10', descripcion: '10xx – TURISMO'},
      {id: '17', descripcion: '17xx – PICK UP'}, {id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg'},
      {id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg'}, {id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg'},
      {id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg'}, {id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE'},
      {id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg'}, {id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg'},
      {id: '66', descripcion: '66xx – QUAD ATV'}
    ];/*
    this.clasif = [
      {id: "00", descripcion: "00-CAMION"},
      {id: "01", descripcion: "01-CAMION PLATAFORMA"},
      {id: "02", descripcion: "02-CAMION CAJA"},
      {id: "03", descripcion: "03-CAMION FURGON"},
      {id: "04", descripcion: "04-CAMION BOTELLERO"},
      {id: "05", descripcion: "05-CAMION CISTERNA"},
      {id: "06", descripcion: "06-CAMION JAULA"},
      {id: "07", descripcion: "07-CAMION FRIGORIFICO"},
      {id: "08", descripcion: "08-CAMION TALLER"},
      {id: "09", descripcion: "09-CAMION PARA CANTERA"},
      {id: "0A", descripcion: "0A-CAMION PORTAVEHICULOS"},
      {id: "0B", descripcion: "0B-CAMION MIXTO"},
      {id: "0C", descripcion: "0C-CAMION PORTACONTENEDORES"},
      {id: "0D", descripcion: "0D-CAMION BASURERO"},
      {id: "0E", descripcion: "0E-CAMION ISOTERMO"},
      {id: "0F", descripcion: "0F-CAMION SILO"},
      {id: "0G", descripcion: "0G-VEHICULO MIXTO ADAPTABLE"},
      {id: "10", descripcion: "10-CAMION ARTICULADO"},
      {id: "11", descripcion: "11-CAMION ARTICULADO PLATAFORMA"},
      {id: "12", descripcion: "12-CAMION ARTICULADO CAJA"},
      {id: "13", descripcion: "13-CAMION ARTICULADO FURGON"},
      {id: "14", descripcion: "14-CAMION ARTICULADO BOTELLERO"},
      {id: "15", descripcion: "15-CAMION ARTICULADO CISTERNA"},
      {id: "16", descripcion: "16-CAMION ARTICULADO JAULA"},
      {id: "17", descripcion: "17-CAMION ARTICULADO FRIGORIFICO"},
      {id: "18", descripcion: "18-CAMION ARTICULADO TALLER"},
      {id: "19", descripcion: "19-CAMION ARTICULADO PARA CANTERA"},
      {id: "1A", descripcion: "1A-CAMION ARTICULADO VIVIENDA O CARAVANA"},
      {id: "1C", descripcion: "1C-CAMION ARTICULADO HORMIGONERA"},
      {id: "1D", descripcion: "1D-CAMION ARTICULADO VOLQUETE"},
      {id: "1E", descripcion: "1E-CAMION ARTICULADO GRUA"},
      {id: "1F", descripcion: "1F-CAMION ARTICULADO CONTRA INCENDIOS"},
      {id: "20", descripcion: "20-FURGONETA"},
      {id: "21", descripcion: "21-FURGONETA MIXTA"},
      {id: "22", descripcion: "22-AMBULANCIA"},
      {id: "23", descripcion: "23-COCHE FUNEBRE"},
      {id: "24", descripcion: "24-CAMIONETA"},
      {id: "25", descripcion: "25-TODO TERRENO"},
      {id: "30", descripcion: "30-AUTOBUS"},
      {id: "31", descripcion: "31-AUTOBUS ARTICULADO"},
      {id: "32", descripcion: "32-AUTOBUS MIXTO"},
      {id: "40", descripcion: "40-TURISMO"},
      {id: "50", descripcion: "50-MOTOCICLETA DE 2 RUEDAS SIN SIDECAR"},
      {id: "51", descripcion: "51-MOTOCICLETA CON SIDECAR"},
      {id: "52", descripcion: "52-MOTOCARRO"},
      {id: "53", descripcion: "53-AUTOMOVIL DE 3 RUEDAS"},
      {id: "54", descripcion: "54-CUATRICICLO"},
      {id: "60", descripcion: "60-COCHE DE INVALIDO"},
      {id: "70", descripcion: "70-VEHICULO ESPECIAL"},
      {id: "80", descripcion: "80-TRACTOR AGRICOLA"},
      {id: "81", descripcion: "81-TRACTOR INDUSTRIAL"},
      {id: "82", descripcion: "82-MAQUINARIA AUTOPROPULSADA"},
      {id: "90", descripcion: "90-SEMIRREMOLQUE"},
      {id: "91", descripcion: "91-REMOLQUE"},
      {id: "92", descripcion: "92-REMOLQUE ESPECIAL"},
      {id: "93", descripcion: "93-SEMIRREMOLQUE FRIGORIFICO"},
      {id: "94", descripcion: "94-SEMIRREMOLQUE CISTERNA"},
      {id: "95", descripcion: "95-SEMIRREMOLQUE PORTAVEHICULOS"},
      {id: "96", descripcion: "96-SEMIRREMOLQUE VOLQUETE"},
      {id: "97", descripcion: "97-REMOLQUE CARAVANA"},
      {id: "98", descripcion: "98-SEMIRREMOLQUE GRUA"},
      {id: "99", descripcion: "99-SEMIRREMOLQUE TALLER"},
      {id: "9A", descripcion: "9A-REMOLQUE VIVIENDA O CARAVANA"},
      {id: "9B", descripcion: "9B-REMOLQUE PLATAFORMA"},
      {id: "9C", descripcion: "9C-REMOLQUE CARGA ESPECIAL"},
      {id: "9D", descripcion: "9D-REMOLQUE BASCULANTE"},
      {id: "9E", descripcion: "9E-REMOLQUE HORMIGONERA"},
      {id: "9F", descripcion: "9F-REMOLQUE CISTERNA"},
      {id: "9G", descripcion: "9G-REMOLQUE JAULA"},
      {id: "9H", descripcion: "9H-REMOLQUE PORTACONTENEDORES"},
      {id: "9J", descripcion: "9J-REMOLQUE TALLER"},
      {id: "9K", descripcion: "9K-REMOLQUE PARA CANTERA"},
      {id: "9L", descripcion: "9L-REMOLQUE GRUA"},
      {id: "9M", descripcion: "9M-REMOLQUE CONTRA INCENDIOS"}
    ];*/
  }

  setDato(datos): void {
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    if (datos.clasificacion !== null) {
      const clasif = datos.clasificacion.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
      console.log(this.datosVehiculos.value.tipoVehiculo);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
  }

  getDatosEITV(): void{
    if(this.datosVehiculos.get('bastidor').value=="" || this.datosVehiculos.get('bastidor').invalid)
    {
      Swal.fire('', 'Se necesita un bastidor válido para recuperar los datos del vehículo desde la DGT', 'warning');
    }
    else{
      this.spinnerEITV=true;
      this.servicio.getEITV(this.datosVehiculos.get('bastidor').value).subscribe({
        next: value => {
          console.log(value.content);
          if(value.error=='ERROR')
            Swal.fire('', 'Error recuperando los datos: '+value.content+ '. Por favor rellene manualmente los datos.', 'warning');
          else
          {
            Swal.fire('', 'Datos EITV recuperados con éxito', 'success');
            console.log(value.content.datos.EMISION_CO2);
            this.datosVehiculos.controls.marca.setValue(value.content.datos.MARCA);
            this.datosVehiculos.controls.modelo.setValue(value.content.datos.MODELO);
            //this.datosVehiculos.controls.matricula.setValue(value.content.datos.MATRICULA);
            this.datosVehiculos.controls.tipoVehiculo.setValue(value.content.datos.CLASIFICACION_VEHICULO.slice(0, 2));
          }
        },
        error: err => {
          console.log(err);
          Swal.fire('', 'Imposible conectar con la DGT, por favor compruebe el bastidor y si es correcto rellene manualmente los datos del vehículo', 'warning');
        },
        complete: () => {
          this.spinnerEITV = false;
        }
      });
    }
  }

}
